import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { initFormHandler } from '../../../../Handler/FormHandler';
import { Box, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, IconButton, MenuItem, TextField, Tooltip, Typography } from '@mui/material';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import SelectComponent from '../../../../Component/SelectComponent/SelectComponent';
import MultipleSelectComponent from '../../../../Component/MultipleSelectComponent/MultipleSelectComponent';
import ButtonComponent from '../../../../Component/ButtonComponent/ButtonComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';
import moment from 'moment';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import { Delete, Edit, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import TabsComponent from '../../../../Component/TabsComponent/TabsComponent';
import { TableReload } from '../../../../Reducer/TableReducer/TableSlice';
import { formatDuration } from '../../../../Common/DurationCommon';
import Swal from "sweetalert2";

function CrmCustomer(props) {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [isEdit, setIsEdit] = React.useState(true);
    const [info, setInfo] = React.useState();
    const [optionsPrestation, setOptionsPrestation] = React.useState([]);
    const [optionsComplement, setOptionsComplement] = React.useState([]);
    const [optionsStatus, setOptionsStatus] = React.useState([]);
    const [optionsSlots, setOptionsSlots] = React.useState([]);
    const [optionsProducts, setOptionsProducts] = React.useState([]);
    const [expandedPurchaseRows, setExpandedPurchaseRows] = React.useState({});
    const [customerPurchaseTotal, setCustomerPurchaseTotal] = React.useState(0);
    const [customerPurchaseCount, setCustomerPurchaseCount] = React.useState(0);
    const [showCustomerDialog, setShowCustomerDialog] = React.useState(false);
    const [showAppointmentDialog, setShowAppointmentDialog] = React.useState(false);
    const [showPurchaseDialog, setShowPurchaseDialog] = React.useState(false);
    const [editingPurchaseId, setEditingPurchaseId] = React.useState(null);
    const [purchaseItems, setPurchaseItems] = React.useState([{ productId: '', quantity: 1 }]);
    const params = useParams();
    const navigate = useNavigate();
    const appointmentTableId = `crm_customer_appointment_history_${info?.id ?? 'new'}`;
    const purchaseTableId = `crm_customer_purchase_history_${info?.id ?? 'new'}`;
    const today = moment().format('YYYY-MM-DD');

    const [form, setForm] = React.useState({
        firstname: {
            name: "firstname",
            label: "Prénom",
            textHelper: "Saisissez le prenom.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        lastname: {
            name: "lastname",
            label: "Nom",
            textHelper: "Saisissez le nom.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        email: {
            name: "email",
            label: "Email",
            textHelper: "Saisissez l'email.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required", "email"] },
        },
        telephone: {
            name: "telephone",
            label: "Téléphone",
            textHelper: "Saisissez le téléphone.",
            type: "text",
            defaultValue: "",
            options: { max: 30 },
        },
        customerNote: {
            name: "note",
            label: "Bloc-notes",
            textHelper: "Ajoutez des notes internes sur ce client.",
            type: "text",
            defaultValue: "",
            options: { max: 5000 },
        },
        password: {
            name: "password",
            label: "Mot de passe",
            textHelper: "Saisissez le mot de passe.",
            type: "password",
            defaultValue: "",
            // options: { validation: ["required"] },
            options: {  },
        }
    });
    const handlerForm = initFormHandler(form, setForm);
    React.useEffect(() => {
        handlerForm.start();
    }, [handlerForm]);

    const [appointmentForm, setAppointmentForm] = React.useState({
        prestationId: {
            name: "prestationId",
            label: "Prestation",
            textHelper: "Sélectionnez une prestation.",
            type: "integer",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        complementIds: {
            name: "complementIds",
            label: "Compléments",
            textHelper: "Optionnel. Disponibles selon la prestation choisie.",
            type: "array",
            defaultValue: [],
            options: {},
        },
        date: {
            name: "date",
            label: "Date",
            textHelper: "Format: YYYY-MM-DD",
            type: "text",
            defaultValue: "",
            options: { validation: ["required", "date"] },
        },
        startAt: {
            name: "startAt",
            label: "Plage horaire disponible",
            textHelper: "Choisissez une heure disponible.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        status: {
            name: "status",
            label: "Statut",
            textHelper: "Statut du rendez-vous.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        note: {
            name: "note",
            label: "Note",
            textHelper: "Optionnel.",
            type: "text",
            defaultValue: "",
            options: { max: 255 },
        },
    });
    const handlerAppointmentForm = initFormHandler(appointmentForm, setAppointmentForm);
    React.useEffect(() => {
        handlerAppointmentForm.start();
    }, [handlerAppointmentForm]);

    const [purchaseForm, setPurchaseForm] = React.useState({
        date: {
            name: "date",
            label: "Date d'achat",
            textHelper: "Date de l'achat en magasin.",
            type: "text",
            defaultValue: today,
            options: { validation: ["required", "date"] },
        },
    });
    const handlerPurchaseForm = initFormHandler(purchaseForm, setPurchaseForm);
    React.useEffect(() => {
        handlerPurchaseForm.start();
    }, [handlerPurchaseForm]);

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'CRM',
            context: isEdit ? 'Éditer un client' : 'Ajouter un client',
            description: '',
            links: [
                { label: "Liste des clients", path: getRoutePathname("crm_customer_list") }
            ]
        });

        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }, [isEdit]);

    React.useEffect(() => {
        if (params.id === 'add') {
            setIsEdit(false);
            setShowCustomerDialog(true);
        }
        else {
            setShowCustomerDialog(false);
            ApiHandler.get({
                route: 'crm_customer_get',
                params: { id: params.id },
            },
                (response) => {
                    if (response.status === 200) {
                        handlerForm.setDataApi(response.data);
                        handlerForm.setValue('customerNote', response.data.note || '');
                        handlerForm.setValue('password', '123456');
                        setInfo(response.data);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                        navigate(getRoutePathname('crm_customer_list'));
                    }
                });
        }
    }, [handlerForm, navigate, params.id]);

    React.useEffect(() => {
        if (!isEdit) return;

        ApiHandler.get({ route: 'crm_appointment_select' }, (response) => {
            if (response.status === 200) {
                setOptionsPrestation(response.data.prestations || []);
                const statuses = response.data.statuses || [];
                setOptionsStatus(statuses);

                if (!handlerAppointmentForm.form.status?.value && statuses.length > 0) {
                    handlerAppointmentForm.setValue('status', statuses[0].value);
                }
            }
        });
    }, [handlerAppointmentForm, isEdit]);

    React.useEffect(() => {
        if (!isEdit || !info?.id) {
            return;
        }

        ApiHandler.get(
            {
                route: 'crm_customer_purchase_select',
                params: { id: info.id },
            },
            (response) => {
                if (response.status === 200) {
                    setOptionsProducts(response.data || []);
                } else {
                    setOptionsProducts([]);
                }
            },
        );
    }, [info?.id, isEdit]);

    React.useEffect(() => {
        setExpandedPurchaseRows({});
    }, [info?.id]);

    React.useEffect(() => {
        setCustomerPurchaseTotal(0);
        setCustomerPurchaseCount(0);
    }, [info?.id]);

    React.useEffect(() => {
        const date = handlerAppointmentForm.form.date?.value;
        const prestationId = handlerAppointmentForm.form.prestationId?.value;
        const complementIds = handlerAppointmentForm.form.complementIds?.value || [];

        if (!date || !prestationId) {
            setOptionsSlots([]);
            return;
        }

        ApiHandler.get(
            {
                route: 'crm_appointment_slots',
                data: {
                    date,
                    prestationId,
                    complementIds,
                },
            },
            (response) => {
                if (response.status === 200) {
                    setOptionsSlots(response.data.slots || []);
                } else {
                    setOptionsSlots([]);
                }
            }
        );
    }, [handlerAppointmentForm, handlerAppointmentForm.form.date?.value, handlerAppointmentForm.form.prestationId?.value, handlerAppointmentForm.form.complementIds?.value]);

    React.useEffect(() => {
        const prestationId = handlerAppointmentForm.form.prestationId?.value;
        const selectedPrestation = optionsPrestation.find((item) => String(item.value) === String(prestationId));
        const complements = selectedPrestation?.complements || [];
        setOptionsComplement(complements);

        const currentValues = Array.isArray(handlerAppointmentForm.form.complementIds?.value)
            ? handlerAppointmentForm.form.complementIds.value
            : [];
        const allowedValues = new Set(complements.map((item) => item.value));
        const nextValues = currentValues.filter((value) => allowedValues.has(value));
        if (nextValues.length !== currentValues.length) {
            handlerAppointmentForm.setValue('complementIds', nextValues);
        }
    }, [handlerAppointmentForm, handlerAppointmentForm.form.prestationId?.value, optionsPrestation]);

    const appointmentColumns = [
        { name: "startAt", label: "Début", options: { filter: true, sort: true } },
        { name: "endAt", label: "Fin", options: { filter: true, sort: true } },
        { name: "prestationLabel", label: "Prestation", options: { filter: true, sort: true } },
        { name: "complementsLabel", label: "Compléments", options: { filter: false, sort: false } },
        { name: "prestationDuration", label: "Durée", options: { filter: true, sort: true } },
        { name: "prestationPrice", label: "Prix (€)", options: { filter: true, sort: true } },
        { name: "status", label: "Statut", options: { filter: true, sort: true } },
        { name: "note", label: "Note", options: { filter: true, sort: false } },
        { name: "createdAt", label: "Créé le", options: { filter: true, sort: true } },
        { name: "action", label: "Action", options: { filter: false, sort: false } },
    ];

    const getAppointmentAction = (row) => (
        <Tooltip title={"Ouvrir le rendez-vous"} placement="left" arrow>
            <IconButton onClick={() => navigate(getRoutePathname('crm_appointment', { id: row.id }))}>
                <Edit />
            </IconButton>
        </Tooltip>
    );

    const togglePurchaseDetails = (purchaseId) => {
        setExpandedPurchaseRows((prev) => ({
            ...prev,
            [purchaseId]: !prev[purchaseId],
        }));
    };

    const addPurchaseItemLine = () => {
        setPurchaseItems((prev) => [...prev, { productId: '', quantity: 1 }]);
    };

    const updatePurchaseItemLine = (index, key, value) => {
        setPurchaseItems((prev) => prev.map((item, itemIndex) => (
            itemIndex === index ? { ...item, [key]: value } : item
        )));
    };

    const removePurchaseItemLine = (index) => {
        setPurchaseItems((prev) => {
            if (prev.length <= 1) {
                return [{ productId: '', quantity: 1 }];
            }

            return prev.filter((_, itemIndex) => itemIndex !== index);
        });
    };

    const openCreatePurchaseDialog = () => {
        setEditingPurchaseId(null);
        handlerPurchaseForm.setValue('date', today);
        setPurchaseItems([{ productId: '', quantity: 1 }]);
        setShowPurchaseDialog(true);
    };

    const openEditPurchaseDialog = (row) => {
        if (!row?.id) {
            return;
        }

        const mappedItems = Array.isArray(row.products) && row.products.length > 0
            ? row.products.map((product) => ({
                productId: String(product.id),
                quantity: Number.isInteger(Number(product.quantity)) && Number(product.quantity) > 0
                    ? Number(product.quantity)
                    : 1,
            }))
            : [{ productId: '', quantity: 1 }];

        setEditingPurchaseId(row.id);
        handlerPurchaseForm.setValue('date', row.dateRaw || today);
        setPurchaseItems(mappedItems);
        setShowPurchaseDialog(true);
    };

    const closePurchaseDialog = () => {
        setShowPurchaseDialog(false);
        setEditingPurchaseId(null);
    };

    const getPurchaseDetailsCell = (row) => {
        const isOpen = !!expandedPurchaseRows[row.id];
        const products = Array.isArray(row.products) ? row.products : [];
        const totalPriceValue = !Number.isNaN(Number(row.totalPriceValue))
            ? Number(row.totalPriceValue)
            : 0;

        return (
            <Box sx={{ width: '100%' }}>
                <Tooltip title={isOpen ? "Masquer les produits" : "Voir les produits"} placement="left" arrow>
                    <IconButton onClick={() => togglePurchaseDetails(row.id)}>
                        {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </Tooltip>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <Box sx={{ mt: 1, mb:1, p: 1, border: '1px solid #ddd', borderRadius: 1, width: '100%', minWidth: 0, maxWidth: '100%' }}>
                        {products.length > 0 ? (
                            products.map((product) => (
                                <Box
                                    key={`purchase-product-${row.id}-${product.id}`}
                                    sx={{ display: 'grid', gridTemplateColumns: '36px minmax(0, 1fr) auto auto', columnGap: 1, py: 0.5, alignItems: 'start' }}
                                >
                                    <Box component="span">{product.id}</Box>
                                    <Box component="span" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>{product.label}</Box>
                                    <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                                        x{!Number.isNaN(Number(product.quantity)) ? Number(product.quantity) : 1}
                                    </Box>
                                    <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                                        {!Number.isNaN(Number(product.linePrice))
                                            ? Number(product.linePrice).toFixed(2)
                                            : !Number.isNaN(Number(product.price))
                                                ? (Number(product.price) * (!Number.isNaN(Number(product.quantity)) ? Number(product.quantity) : 1)).toFixed(2)
                                                : '-'} €
                                    </Box>
                                </Box>
                            ))
                        ) : (
                            <span>Aucun produit.</span>
                        )}
                        <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid #eee', fontWeight: 600 }}>
                            Total: {totalPriceValue.toFixed(2)} €
                        </Box>
                    </Box>
                </Collapse>
            </Box>
        );
    };

    const purchaseColumns = [
        { name: "date", label: "Date d'achat", options: { filter: true, sort: true } },
        { name: "totalPrice", label: "Total (€)", options: { filter: true, sort: true } },
        {
            name: "details",
            label: "Produits",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => getPurchaseDetailsCell(value),
            },
        },
        { name: "action", label: "Action", options: { filter: false, sort: false } },
    ];

    const getPurchaseAction = (row) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
            <Tooltip title={"Modifier l'achat"} placement="left" arrow>
                <IconButton onClick={() => openEditPurchaseDialog(row)}>
                    <Edit />
                </IconButton>
            </Tooltip>
            <Tooltip title={"Supprimer l'achat"} placement="left" arrow>
                <IconButton
                    onClick={() => {
                        Swal.fire({
                            title: "Supprimer cet achat ?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#87bba4",
                            cancelButtonColor: "var(--greytext)",
                            confirmButtonText: "Confirmer",
                            cancelButtonText: "Annuler",
                            reverseButtons: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                ApiHandler.delete(
                                    {
                                        route: "crm_customer_purchase_delete",
                                        params: { id: info.id, purchaseId: row.id },
                                    },
                                    (response) => {
                                        if (response.status === 200) {
                                            dispatch(TableReload(purchaseTableId));
                                            dispatch(
                                                SnackbarOpen({
                                                    text: "Achat supprimé avec succès",
                                                    variant: "success",
                                                }),
                                            );
                                        } else {
                                            dispatch(
                                                SnackbarOpen({
                                                    text:
                                                        response.error && response.error.message
                                                            ? response.error.message
                                                            : "Une erreur inattendu s'est produite.",
                                                    variant: "error",
                                                }),
                                            );
                                        }
                                    },
                                );
                            }
                        });
                    }}
                >
                    <Delete />
                </IconButton>
            </Tooltip>
        </Box>
    );

    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            ApiHandler.post(
                {
                    route: isEdit ? "crm_customer_edit" : "crm_customer_add",
                    params: isEdit ? { id: info.id } : "",
                    data: handlerForm.getData(),
                },
                (response) => {
                    if (response.status === 200 || response.status === 201) {
                        if (response.status === 201) {
                            navigate(getRoutePathname('crm_customer', {id: response.data.id}));
                            setIsEdit(true);
                        }
                        setShowCustomerDialog(false);
                        dispatch(
                            SnackbarOpen({
                                text: isEdit ? "Client modifié avec succès" : "Client crée avec succès",
                                variant: "success",
                            }),
                        );
                    } else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerForm.setFormLoading(false);
                },
            );
        }
    };

    const saveAppointment = () => {
        if (!info?.id) return;
        if (handlerAppointmentForm.checkError() < 1) {
            handlerAppointmentForm.setFormLoading(true);
            const data = handlerAppointmentForm.getData();

            ApiHandler.post(
                {
                    route: "crm_appointment_add",
                    data: {
                        customerId: info.id,
                        prestationId: data.prestationId,
                        complementIds: Array.isArray(data.complementIds)
                            ? data.complementIds
                                .map((value) => parseInt(value, 10))
                                .filter((value) => Number.isInteger(value) && value > 0)
                            : [],
                        startAt: data.startAt,
                        status: data.status,
                        note: data.note || null,
                    },
                },
                (response) => {
                    if (response.status === 201 || response.status === 200) {
                        dispatch(
                            SnackbarOpen({
                                text: "Rendez-vous créé avec succès",
                                variant: "success",
                            }),
                        );
                        setShowAppointmentDialog(false);
                        dispatch(TableReload(appointmentTableId));
                        handlerAppointmentForm.setValue('prestationId', '');
                        handlerAppointmentForm.setValue('complementIds', []);
                        handlerAppointmentForm.setValue('date', '');
                        handlerAppointmentForm.setValue('startAt', '');
                        handlerAppointmentForm.setValue('note', '');
                        setOptionsSlots([]);
                    } else if (response.status === 400) {
                        handlerAppointmentForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerAppointmentForm.setFormLoading(false);
                }
            );
        }
    };

    const savePurchase = () => {
        if (!info?.id) return;
        if (handlerPurchaseForm.checkError() < 1) {
            const isPurchaseEditMode = editingPurchaseId !== null;
            const normalizedProducts = purchaseItems
                .map((item) => ({
                    productId: parseInt(item.productId, 10),
                    quantity: parseInt(item.quantity, 10),
                }))
                .filter((item) => Number.isInteger(item.productId) && item.productId > 0 && Number.isInteger(item.quantity) && item.quantity > 0);

            if (normalizedProducts.length < 1) {
                dispatch(
                    SnackbarOpen({
                        text: "Ajoutez au moins un produit avec une quantité valide.",
                        variant: "error",
                    }),
                );
                return;
            }

            handlerPurchaseForm.setFormLoading(true);
            const data = handlerPurchaseForm.getData();

            ApiHandler.post(
                {
                    route: isPurchaseEditMode ? "crm_customer_purchase_edit" : "crm_customer_purchase_add",
                    params: isPurchaseEditMode
                        ? { id: info.id, purchaseId: editingPurchaseId }
                        : { id: info.id },
                    data: {
                        date: data.date,
                        products: normalizedProducts,
                    },
                },
                (response) => {
                    if (response.status === 201 || response.status === 200) {
                        dispatch(
                            SnackbarOpen({
                                text: isPurchaseEditMode ? "Achat modifié avec succès" : "Achat ajouté avec succès",
                                variant: "success",
                            }),
                        );
                        closePurchaseDialog();
                        dispatch(TableReload(purchaseTableId));
                        handlerPurchaseForm.setValue('date', today);
                        setPurchaseItems([{ productId: '', quantity: 1 }]);
                    } else if (response.status === 400) {
                        handlerPurchaseForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerPurchaseForm.setFormLoading(false);
                },
            );
        }
    };

    const closeCustomerDialog = () => {
        if (!isEdit) {
            navigate(getRoutePathname('crm_customer_list'));
            return;
        }

        setShowCustomerDialog(false);
    };

    const customerFullName = `${handlerForm.form.firstname?.value || info?.firstname || ''} ${handlerForm.form.lastname?.value || info?.lastname || ''}`.trim() || '-';
    const customerEmail = handlerForm.form.email?.value || info?.email || '-';
    const customerPhone = handlerForm.form.telephone?.value || info?.telephone || '-';
    const customerNote = handlerForm.form.customerNote?.value || info?.note || '-';
    const customerInitials = customerFullName !== '-'
        ? customerFullName
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((value) => value.charAt(0).toUpperCase())
            .join('')
        : 'CL';
    const customerPurchaseTotalLabel = `${customerPurchaseTotal.toFixed(2)} €`;

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            p: { xs: 1.5, md: 2 },
                            borderRadius: 2,
                            border: '1px solid #d6deea',
                            background: 'linear-gradient(135deg, #f8fbff 0%, #ffffff 100%)',
                            boxShadow: '0 1px 4px rgba(32, 47, 66, 0.08)',
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, mb: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                <Box
                                    sx={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: 'linear-gradient(135deg, #5ca7e0 0%, #57A585 100%)',
                                        color: '#fff',
                                        fontSize: 15,
                                        fontWeight: 700,
                                        letterSpacing: 0.4,
                                    }}
                                >
                                    {customerInitials}
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.4, color: '#6a7a92' }}>
                                        Fiche client
                                    </Typography>
                                    <Typography sx={{ fontSize: { xs: 20, md: 24 }, lineHeight: 1.2, fontWeight: 700, color: '#2d3b52' }}>
                                        {customerFullName}
                                    </Typography>
                                </Box>
                            </Box>
                            <ButtonComponent
                                small
                                label={isEdit ? "Modifier les informations" : "Renseigner le client"}
                                onClick={() => setShowCustomerDialog(true)}
                            />
                        </Box>

                        <Grid container spacing={1}>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Box sx={{ p: 1.2, border: '1px solid #d0dfef', borderRadius: 1.5, background: 'linear-gradient(135deg, #eef6ff 0%, #ffffff 100%)' }}>
                                    <Typography sx={{ fontSize: 11, textTransform: 'uppercase', color: '#6f80a0' }}>Total achats produits</Typography>
                                    <Typography sx={{ fontSize: 23, lineHeight: 1.1, fontWeight: 700, color: '#275d8f', mt: 0.4 }}>
                                        {customerPurchaseTotalLabel}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: '#6f80a0', mt: 0.2 }}>
                                        {customerPurchaseCount} achat{customerPurchaseCount > 1 ? 's' : ''} enregistré{customerPurchaseCount > 1 ? 's' : ''}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                                <Box sx={{ p: 1, border: '1px solid #e1e8f2', borderRadius: 1, backgroundColor: '#fff' }}>
                                    <Typography sx={{ fontSize: 11, textTransform: 'uppercase', color: '#7d8ca5' }}>Email</Typography>
                                    <Typography sx={{ fontSize: 14, color: '#2f3947', overflowWrap: 'anywhere' }}>{customerEmail}</Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                                <Box sx={{ p: 1, border: '1px solid #e1e8f2', borderRadius: 1, backgroundColor: '#fff' }}>
                                    <Typography sx={{ fontSize: 11, textTransform: 'uppercase', color: '#7d8ca5' }}>Téléphone</Typography>
                                    <Typography sx={{ fontSize: 14, color: '#2f3947' }}>{customerPhone}</Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                                <Box sx={{ p: 1, border: '1px solid #e1e8f2', borderRadius: 1, backgroundColor: '#fff' }}>
                                    <Typography sx={{ fontSize: 11, textTransform: 'uppercase', color: '#7d8ca5' }}>Identifiant</Typography>
                                    <Typography sx={{ fontSize: 14, color: '#2f3947' }}>{info?.id ? `#${info.id}` : '-'}</Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 8 }}>
                                <Box sx={{ p: 1, border: '1px solid #e1e8f2', borderRadius: 1, backgroundColor: '#fff' }}>
                                    <Typography sx={{ fontSize: 11, textTransform: 'uppercase', color: '#7d8ca5' }}>Bloc-notes</Typography>
                                    <Typography sx={{ fontSize: 14, color: '#2f3947', whiteSpace: 'pre-wrap' }}>{customerNote}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                {isEdit && (
                    <Grid size={{ xs: 12 }}>
                        <Box sx={{ mt: 3 }}>
                            <TabsComponent
                                tabDefault={'appointments'}
                                tabs={[
                                    { key: 'appointments', label: 'Rendez-vous' },
                                    { key: 'purchase_history', label: 'Achats produits' },
                                ]}
                            >
                                <div key={'appointments'}>
                                    <TableComponent
                                        id={appointmentTableId}
                                        title={'Rendez-vous du client'}
                                        columns={appointmentColumns}
                                        mobileMode={'cards'}
                                        actionFirst={{
                                            label: "Ajouter un rendez-vous",
                                            onClick: () => setShowAppointmentDialog(true),
                                        }}
                                        promiseData={(resolve) => {
                                            ApiHandler.get(
                                                {
                                                    route: 'crm_appointment_list',
                                                    data: {
                                                        limit: 5000,
                                                        offset: 0,
                                                        sortName: 'startAt',
                                                        sortDirection: 'desc',
                                                        customerId: info?.id,
                                                    },
                                                },
                                                (response) => {
                                                    if (response.status === 200) {
                                                        const rows = response.data.data || [];
                                                        for (let index in rows) {
                                                            rows[index].startAt = moment(rows[index].startAt).format('DD/MM/YYYY HH:mm');
                                                            rows[index].endAt = moment(rows[index].endAt).format('HH:mm');
                                                            rows[index].complementsLabel = Array.isArray(rows[index].complements) && rows[index].complements.length > 0
                                                                ? rows[index].complements.map((value) => value.label).join(', ')
                                                                : '-';
                                                            rows[index].prestationDuration =
                                                                rows[index].effectiveDuration !== null && rows[index].effectiveDuration !== undefined
                                                                    ? formatDuration(rows[index].effectiveDuration)
                                                                    : rows[index].prestationDuration !== null && rows[index].prestationDuration !== undefined
                                                                        ? formatDuration(rows[index].prestationDuration)
                                                                        : '-';
                                                            rows[index].prestationPrice = rows[index].effectivePrice !== null && rows[index].effectivePrice !== undefined
                                                                ? Number(rows[index].effectivePrice).toFixed(2)
                                                                : '-';
                                                            rows[index].note = rows[index].note || '-';
                                                            rows[index].createdAt = rows[index].createdAt ? moment(rows[index].createdAt).format('ll') : '-';
                                                            rows[index].action = getAppointmentAction(rows[index]);
                                                        }
                                                        resolve(rows);
                                                    } else {
                                                        resolve([]);
                                                    }
                                                }
                                            );
                                        }}
                                    />
                                </div>
                                <div key={'purchase_history'}>
                                    <TableComponent
                                        id={purchaseTableId}
                                        title={'Suivi des achats produits'}
                                        columns={purchaseColumns}
                                        mobileMode={'cards'}
                                        actionFirst={{
                                            label: "Ajouter un achat",
                                            onClick: openCreatePurchaseDialog,
                                        }}
                                        promiseData={(resolve) => {
                                            if (!info?.id) {
                                                setCustomerPurchaseTotal(0);
                                                setCustomerPurchaseCount(0);
                                                resolve([]);
                                                return;
                                            }

                                            ApiHandler.get(
                                                {
                                                    route: 'crm_customer_purchase_list',
                                                    params: { id: info?.id },
                                                },
                                                (response) => {
                                                    if (response.status === 200) {
                                                        const rows = response.data || [];
                                                        let nextTotal = 0;
                                                        for (let index in rows) {
                                                            rows[index].dateRaw = rows[index].date;
                                                            rows[index].date = rows[index].date ? moment(rows[index].date).format('ll') : '-';
                                                            rows[index].totalPriceValue = rows[index].totalPrice;
                                                            rows[index].totalPrice = !Number.isNaN(Number(rows[index].totalPrice))
                                                                ? Number(rows[index].totalPrice).toFixed(2)
                                                                : '-';
                                                            nextTotal += !Number.isNaN(Number(rows[index].totalPriceValue))
                                                                ? Number(rows[index].totalPriceValue)
                                                                : 0;
                                                            rows[index].details = {
                                                                id: rows[index].id,
                                                                products: rows[index].products,
                                                                totalPriceValue: rows[index].totalPriceValue,
                                                            };
                                                            rows[index].action = getPurchaseAction(rows[index]);
                                                        }
                                                        setCustomerPurchaseTotal(nextTotal);
                                                        setCustomerPurchaseCount(rows.length);
                                                        resolve(rows);
                                                    } else {
                                                        setCustomerPurchaseTotal(0);
                                                        setCustomerPurchaseCount(0);
                                                        resolve([]);
                                                    }
                                                },
                                            );
                                        }}
                                    />
                                </div>
                            </TabsComponent>
                        </Box>
                    </Grid>
                )}
            </Grid>

            <Dialog open={showCustomerDialog} maxWidth={"md"} fullWidth onClose={closeCustomerDialog}>
                <DialogTitle style={{ fontSize: 15 }}>
                    {isEdit ? "Modifier le client" : "Ajouter un client"}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1} sx={{ mt: 0.5 }}>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <TextFieldComponent id={"lastname"} handler={handlerForm} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <TextFieldComponent id={"firstname"} handler={handlerForm} />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <TextFieldComponent id={"email"} handler={handlerForm} />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <TextFieldComponent id={"telephone"} handler={handlerForm} />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <TextFieldComponent id={"customerNote"} handler={handlerForm} multiline />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent
                        color={"var(--greytext)"}
                        label={"Annuler"}
                        onClick={closeCustomerDialog}
                    />
                    <ButtonComponent
                        label={"Enregistrer"}
                        onClick={save}
                        loading={handlerForm.formLoading}
                    />
                </DialogActions>
            </Dialog>

            <Dialog open={showAppointmentDialog} maxWidth={"md"} fullWidth onClose={() => setShowAppointmentDialog(false)}>
                <DialogTitle style={{ fontSize: 15 }}>
                    Ajouter un rendez-vous
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1} sx={{ mt: 0.5 }}>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <SelectComponent id={"prestationId"} options={optionsPrestation} handler={handlerAppointmentForm} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <MultipleSelectComponent id={"complementIds"} options={optionsComplement} handler={handlerAppointmentForm} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className={'content-textfield'}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label="Date *"
                                    className="textField"
                                    value={handlerAppointmentForm.form.date?.value || ''}
                                    onChange={(event) => handlerAppointmentForm.setValue('date', event.target.value)}
                                    inputProps={{ min: today }}
                                    InputLabelProps={{ shrink: true }}
                                    helperText={handlerAppointmentForm.form.date?.error || handlerAppointmentForm.form.date?.textHelper}
                                    error={!!handlerAppointmentForm.form.date?.error}
                                />
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <SelectComponent id={"startAt"} options={optionsSlots} handler={handlerAppointmentForm} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <SelectComponent id={"status"} options={optionsStatus} handler={handlerAppointmentForm} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <TextFieldComponent id={"note"} handler={handlerAppointmentForm} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent
                        color={"var(--greytext)"}
                        label={"Annuler"}
                        onClick={() => setShowAppointmentDialog(false)}
                    />
                    <ButtonComponent
                        label={"Créer le rendez-vous"}
                        onClick={saveAppointment}
                    />
                </DialogActions>
            </Dialog>

            <Dialog open={showPurchaseDialog} maxWidth={"md"} fullWidth onClose={closePurchaseDialog}>
                <DialogTitle style={{ fontSize: 15 }}>
                    {editingPurchaseId !== null ? "Modifier l'achat" : "Ajouter un achat"}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1} sx={{ mt: 0.5 }}>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <div className={'content-textfield'}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label="Date d'achat *"
                                    className="textField"
                                    value={handlerPurchaseForm.form.date?.value || ''}
                                    onChange={(event) => handlerPurchaseForm.setValue('date', event.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    helperText={handlerPurchaseForm.form.date?.error || handlerPurchaseForm.form.date?.textHelper}
                                    error={!!handlerPurchaseForm.form.date?.error}
                                />
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Box sx={{ fontSize: 13, color: 'var(--greytext)' }}>Produits et quantités</Box>
                                <ButtonComponent
                                    small
                                    label={"Ajouter un produit"}
                                    onClick={addPurchaseItemLine}
                                />
                            </Box>
                            <Box sx={{ display: 'grid', gap: 1 }}>
                                {purchaseItems.map((item, index) => (
                                    <Box
                                        key={`purchase-item-line-${index}`}
                                        sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 120px 40px', columnGap: 1, alignItems: 'center' }}
                                    >
                                        <TextField
                                            fullWidth
                                            select
                                            size="small"
                                            label={index === 0 ? "Produit *" : "Produit"}
                                            value={item.productId}
                                            onChange={(event) => updatePurchaseItemLine(index, 'productId', event.target.value)}
                                        >
                                            <MenuItem value={''}>Sélectionner</MenuItem>
                                            {optionsProducts.map((option) => (
                                                <MenuItem key={`purchase-product-option-${option.value}`} value={String(option.value)}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            label={index === 0 ? "Quantité *" : "Quantité"}
                                            inputProps={{ min: 1, step: 1 }}
                                            value={item.quantity}
                                            onChange={(event) => updatePurchaseItemLine(index, 'quantity', event.target.value)}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={() => removePurchaseItemLine(index)}
                                            disabled={purchaseItems.length <= 1}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent
                        color={"var(--greytext)"}
                        label={"Annuler"}
                        onClick={closePurchaseDialog}
                    />
                    <ButtonComponent
                        label={editingPurchaseId !== null ? "Enregistrer les modifications" : "Ajouter l'achat"}
                        onClick={savePurchase}
                    />
                </DialogActions>
            </Dialog>
        </ContentViewComponent>
    );
}

export default CrmCustomer;
